module.exports = __webpack_public_path__ + "static/media/tigger_soundi_visoki_1.639d7e24.mp3";